import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "number3Circle"
const Number3CircleIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <title>{iconSource}</title>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm2 0c0 6.075-4.925 11-11 11S1 18.075 1 12 5.925 1 12 1s11 4.925 11 11Zm-11.145 5.65c-1.305 0-2.55-.585-3.48-1.635L9.83 14.8c.435.615 1.155 1.05 1.95 1.05.99 0 1.965-.78 1.965-1.905 0-1.095-.9-1.92-2.07-1.92-.42 0-.87.105-1.26.3v-1.2L12.38 8.8H8.87V7h6.375v1.2l-1.905 2.34c1.44.555 2.43 1.815 2.43 3.405 0 2.22-1.74 3.705-3.915 3.705Z"
          />
        </svg>
      }
    </span>
  )
}
export default Number3CircleIcon
